<template>
  <!-- partial -->
  <div class="page-content">
    <div class="row">
      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
        <h5 class="txt-dark">
          <back-button
            link="/procurement-management/parent-account-code-groups"
          ></back-button>
          Add Parent Account Code Group
        </h5>
      </div>
      <!-- Breadcrumb -->
      <div class="col-lg-6 col-sm-6 col-md-6 col-xs-12">
        <ol class="breadcrumb breadcrumb-line" style="float: right">
          <li class="breadcrumb-item">
            <router-link :to="`/`">Dashboard</router-link>
          </li>
          <li class="breadcrumb-item">Procurement Management</li>
          <li class="breadcrumb-item">
            <router-link
              :to="`/procurement-management/parent-account-code-groups`"
              >Parent Account Code Groups</router-link
            >
          </li>
          <li class="breadcrumb-item active" aria-current="page">Add</li>
        </ol>
      </div>
    </div>
    <!-- /Breadcrumb -->
    <!-- Form  -->
    <div class="row">
      <div class="col-md-10 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <div class="row mb-3">
              <label class="col-sm-2 col-form-label">Owner</label>
              <div class="col-sm-10">
                <my-select
                  style="margin: 9px !important"
                  disableFormControl="true"
                  :selection.sync="form.owner_id"
                  :suggestions="owners"
                  placeholder="Select owner"
                ></my-select>
              </div>
            </div>
            <div class="row mb-3">
              <label class="col-sm-2 col-form-label">Parent Account Name</label>
              <div class="col-sm-10">
                <input
                  type="text"
                  v-model="form.parent_account_name"
                  class="form-control"
                  autocomplete="off"
                  placeholder="Parent Account Name"
                />
              </div>
            </div>
            <div class="row mb-3">
              <label class="col-sm-2 col-form-label">Parent Account Code</label>
              <div class="col-sm-10">
                <input
                  type="text"
                  v-model="form.parent_account_code"
                  class="form-control"
                  placeholder="Parent Account Code"
                />
              </div>
            </div>
            <div class="form-group mb-0">
              <submit-button
                :isLoading="isLoading"
                @submit="save"
                text="Save"
                style="float: right"
              ></submit-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- partial -->
</template>
<script type="text/javascript">
import axios from "axios";

export default {
  name: "ParentAccountCodeGroupCreate",
  data() {
    return {
      form: {
        owner_id: "",
      },
      owners: [],
      isLoading: false,
    };
  },
  mounted() {
    this.getMasters();
  },
  methods: {
    async getMasters() {
      let masters = await axios.get("parent_account_code_groups/masters");
      masters = masters.data;
      masters.owners.forEach((owner) => {
        this.owners.push({
          id: owner.id,
          name: owner.name,
        });
      });
    },
    async save() {
      try {
        this.isLoading = true;
        await axios.post("/parent_account_code_groups", this.form);
        this.isLoading = false;
        this.$router.push("/procurement-management/parent-account-code-groups");
      } catch (e) {
        this.isLoading = false;
      }
    },
  },
};
</script>
